<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<!-- 서브메뉴 탭 구성 //-->
<ng-container *ngIf="(currMenu$ | async)['page_cd'].length > 6 && (currMenu$ | async)['parentNode']['children'].length > 0">
  <ul class="sub-tab inner-wrap">
    <li class="nav-item" *ngFor="let item of (currMenu$ | async)['parentNode']['children']; index as i">
      <a class="cp nav-link" [ngClass]="{active: (currMenu$ | async)['seq'] == item.seq}"  (click)="goLink(item)">{{item.page_menu_name}}</a>
    </li>
  </ul>
</ng-container>

<div id="board">
  <div class="inner-wrap">

    <app-board-list *ngIf="params.type=='list'" [boardInfo]="boardInfo" [memberInfo]="memberInfo" [data]="data" [params]="params" [totalCount]="totalCount" [authCheck$]="authCheck$"></app-board-list>
  </div>
</div>
